import { Edge, Handle, Position } from '@xyflow/react';
import { AppNode } from './tracking-diagram';
import { Logo } from '@/components/logos/logo';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ConnectionStatusV2, IntegrationTypeV2, IntegrationV2Properties } from '@/gql/graphql';

export const EDGE_COLOR = '#0e9f6e';

export const COLUMN_WIDTH = 341;
export const VERTICAL_SPACING = 80;
export const BASE_VERTICAL_SPACING = 56;

export const BASE_SCREEN_WIDTH = 1024;
export const MEDIUM_SCREEN_WIDTH = 768;
export const SMALL_SCREEN_WIDTH = 640;

export const SOURCES: IntegrationV2Properties[] = [
  {
    id: 'shopify',
    createdAt: new Date().toISOString(),
    merchantId: '-',
    name: 'Shopify',
    status: ConnectionStatusV2.Connected,
    findFiltersV2: [],
    type: IntegrationTypeV2.Unspecified,
    updatedAt: new Date().toISOString()
  },
  {
    id: 'sub-domain',
    createdAt: new Date().toISOString(),
    merchantId: '-',
    name: 'Sub Domain',
    status: ConnectionStatusV2.Disconnected,
    findFiltersV2: [],
    type: IntegrationTypeV2.Unspecified,
    updatedAt: new Date().toISOString()
  }
];

/**
 * Initial nodes for the React Flow diagram.
 */
export const INITIAL_NODES: AppNode[] = [
  {
    id: 'sources-header',
    type: 'text',
    data: {
      label: 'Sources'
    },
    position: { x: 0, y: 0 }
  },
  {
    id: 'shopify',
    type: 'integration',
    data: {
      label: 'Shopify',
      status: ConnectionStatusV2.Connected,
      icon: <Logo icon="shopify" />,
      handle: (
        <Handle
          type="source"
          position={Position.Right}
          className="w-2 h-2 bg-transparent border-none top-1/2 right-[-5px] pointer-events-none cursor-pointer"
        />
      )
    },
    position: { x: 0, y: BASE_VERTICAL_SPACING }
  },
  {
    id: 'sub-domain',
    type: 'integration',
    data: {
      label: 'Sub Domain',
      status: ConnectionStatusV2.Disconnected,
      icon: <Logo icon="subdomain" />,
      handle: (
        <Handle
          type="source"
          position={Position.Right}
          className="w-2 h-2 bg-transparent border-none top-1/2 right-[-5px] pointer-events-none cursor-pointer"
        />
      )
    },
    position: { x: 0, y: BASE_VERTICAL_SPACING + VERTICAL_SPACING * 1 }
  },
  {
    id: 'contextual',
    type: 'integration',
    data: {
      label: 'Contextual',
      status: ConnectionStatusV2.Connected,
      icon: <Logo icon="contextual" />,
      handle: (
        <>
          <Handle
            type="source"
            position={Position.Right}
            className="w-2 h-2 bg-transparent border-none top-1/2 right-[-5px] pointer-events-none cursor-pointer"
          />
          <Handle
            type="target"
            position={Position.Left}
            className="w-2 h-2 bg-transparent border-none top-1/2 left-[-5px] pointer-events-none cursor-pointer"
          />
        </>
      )
    },
    position: { x: COLUMN_WIDTH, y: BASE_VERTICAL_SPACING }
  },
  {
    id: 'destinations-header',
    type: 'text',
    data: {
      label: 'Destinations',
      button: (
        <Button variant="link" asChild>
          <Link to=".?new">
            <span className="mr-2">
              <Plus size={18} />
            </span>
            Add integration
          </Link>
        </Button>
      )
    },
    position: { x: COLUMN_WIDTH * 2, y: 0 }
  }
];

/**
 * Initial edges for the React Flow diagram.
 */
export const INITIAL_EDGES: Edge[] = [
  {
    id: 'shopify-contextual',
    source: 'shopify',
    target: 'contextual',
    animated: true,
    style: { stroke: EDGE_COLOR }
  }
];
